export default {
    chatraId: 'm5FCNMijBcHzzP2Kr',
    //baseURL: 'http://localhost:8001',
    baseURL: 'https://admin.cohntm.com'
}
